import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import * as emailsSelectors from 'ContentData/selectors/emails';
import * as EmailsActions from 'ContentData/actions/Emails';
import { convertLegacyFollowupEmail } from 'ContentData/api/Emails';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function mapStateToProps(state, props) {
  const {
    emailId
  } = props;
  return {
    email: emailId ? emailsSelectors.getEmail(state, {
      id: emailId
    }) : null,
    hasFetchedIsLegacyEmailConvertible: emailsSelectors.getHasFetchedIsLegacyEmailConvertible(state, {
      id: emailId
    }),
    isLegacyEmailConvertible: emailId ? emailsSelectors.getIsLegacyEmailConvertible(state, {
      id: emailId
    }) : false
  };
}
const mapDispatchToProps = {
  fetchIsLegacyEmailConvertible: EmailsActions.fetchIsLegacyEmailConvertible
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.legacyEmailIsSelectedAlert.${key}`;
const UpgradeEmailModal = ({
  emailName = '',
  isUpgrading,
  onClose,
  onUpgradeEmail
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeModal.header')
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey('upgradeModal.message'),
          options: {
            emailName
          }
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        loading: isUpgrading,
        onClick: onUpgradeEmail,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeModal.upgrade')
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeModal.cancel')
        })
      })]
    })]
  });
};
const RemoveEmailModal = ({
  onClose,
  onRemoveEmail
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeModal.header')
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey('removeModal.message')
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-selenium": "clear-legacy-followup-email-confirm-button",
        onClick: onRemoveEmail,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeModal.upgrade')
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeModal.cancel')
        })
      })]
    })]
  });
};
const showUpgradeError = () => {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('upgradeErrorAlert.message')
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('upgradeErrorAlert.title')
    }),
    type: 'danger'
  });
};
const LegacyEmailAlert = ({
  clearLegacyFollowupEmail,
  fetchIsLegacyEmailConvertible,
  hasFetchedIsLegacyEmailConvertible,
  isLegacyEmailConvertible,
  email,
  emailId,
  onChangeFollowupEmailEvent,
  onFollowupEmailIdChange
}) => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const clearLegacyAndSetFollowupEmailId = () => {
    clearLegacyFollowupEmail(() => {
      onFollowupEmailIdChange(emailId);
      setIsUpgrading(false);
      setIsUpgradeModalOpen(false);
    });
  };
  const onUpgradeEmail = () => {
    setIsUpgrading(true);
    if (!email) {
      setIsUpgrading(false);
      showUpgradeError();
      return;
    }
    if (email.emailType === 'FOLLOWUP_EMAIL') {
      convertLegacyFollowupEmail(email).then(response => {
        const {
          errors = [],
          incomplete
        } = response;
        if (errors.length || incomplete) {
          setIsUpgrading(false);
          showUpgradeError();
          return;
        }
        if (onChangeFollowupEmailEvent) {
          onChangeFollowupEmailEvent('form-followup-email-upgrade-legacy');
        }
        clearLegacyAndSetFollowupEmailId();
      }).catch(() => {
        setIsUpgrading(false);
        showUpgradeError();
      });
    } else {
      clearLegacyAndSetFollowupEmailId();
    }
  };
  const onRemoveEmail = () => {
    if (onChangeFollowupEmailEvent) {
      onChangeFollowupEmailEvent('form-followup-email-remove-legacy');
    }
    clearLegacyFollowupEmail();
    setIsRemoveModalOpen(false);
    return;
  };
  useEffect(() => {
    if (email && !hasFetchedIsLegacyEmailConvertible) {
      fetchIsLegacyEmailConvertible(email.id).catch(err => {
        throw err;
      });
    }
  }, [email, hasFetchedIsLegacyEmailConvertible, fetchIsLegacyEmailConvertible]);
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('title')
    }),
    type: "warning",
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey(isLegacyEmailConvertible ? 'message_jsx' : 'notUpgradableMessage_jsx'),
        options: {
          href: 'https://knowledge.hubspot.com/forms/set-up-and-style-forms-on-hubspot-pages#configure-your-form-automation'
        },
        elements: {
          Link
        }
      }), isUpgradeModalOpen && /*#__PURE__*/_jsx(UpgradeEmailModal, {
        emailName: email && email.name,
        isUpgrading: isUpgrading,
        onClose: () => setIsUpgradeModalOpen(false),
        onUpgradeEmail: onUpgradeEmail
      }), isLegacyEmailConvertible && /*#__PURE__*/_jsx(Button, {
        "data-selenium": "upgrade-legacy-followup-email-button",
        onClick: () => setIsUpgradeModalOpen(true),
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgradeButton')
        })
      }), isRemoveModalOpen && /*#__PURE__*/_jsx(RemoveEmailModal, {
        onClose: () => setIsRemoveModalOpen(false),
        onRemoveEmail: onRemoveEmail
      }), /*#__PURE__*/_jsx(Button, {
        "data-selenium": "clear-legacy-followup-email-button",
        onClick: () => setIsRemoveModalOpen(true),
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('removeButton')
        })
      })]
    })
  });
};
export default connector(LegacyEmailAlert);